import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { components } from 'react-select';
import styled from 'styled-components';
import CloseXsmall from '@elliemae/ds-icons/CloseXsmall';
import DSButton from '@elliemae/ds-button';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var StyledButton = /*#__PURE__*/styled(DSButton).withConfig({
  componentId: "cikqh1-0"
})(["padding-right:8px;width:1.16rem !important;height:auto;z-index:10;color:'#000';"]);

var SingleValueRemove = function SingleValueRemove(props) {
  // eslint-disable-next-line react/prop-types
  var clearValue = props.clearValue;
  return /*#__PURE__*/React.createElement(components.ClearIndicator, props, /*#__PURE__*/React.createElement(StyledButton, _extends({}, props, {
    "aria-label": "clear-indicator",
    buttonType: "text",
    className: "clear-indicator",
    icon: /*#__PURE__*/React.createElement(CloseXsmall, {
      fill: "#000"
    }),
    onClick: function onClick() {
      return clearValue();
    }
  })));
};

SingleValueRemove.style = function (base) {
  return _objectSpread(_objectSpread({}, base), {}, {
    padding: 0,
    height: '16px',
    backgroundColor: '#EBF6FF',
    ':hover': {
      backgroundColor: '#EBF6FF'
    }
  });
};

export { SingleValueRemove };
//# sourceMappingURL=SingleValueRemove.js.map
